import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = ({ size = "medium" }) => {
  return (
    <div className={`${styles.spinner} ${styles[size]}`} aria-label="Loading" />
  );
};

export default LoadingSpinner;